export default __webpack_public_path__ + "static/media/Sash of the Faceless Sphinx.94cf0e04.jpg";